import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ImageCardComponent } from './components/image-card/image-card.component';
import { VerificationDashboardComponent } from './components/verification-dashboard/verification-dashboard.component';

const routes: Routes = [
  { path: 'Dashboard', component: VerificationDashboardComponent },
  { path: 'ImageCard/:projectId', component: ImageCardComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VerificationRoutingModule { }
